(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/race-handler/race/create-race-model.js') >= 0) return;  svs.modules.push('/components/sport/race-handler/race/create-race-model.js');
'use strict';

const resolveTimeZone = svs.components.lbUtils.helpers.formatDate.resolveTimeZone;
const constants = svs.components.sport.raceHandler.common.constants;
const raceSymbol = Symbol('RaceModel');
const isRaceModel = instance => (instance === null || instance === void 0 ? void 0 : instance._symbol) === raceSymbol;
const createRaceId = (productId, drawNumber) => "".concat(productId, "_").concat(drawNumber);
const createRaceModel = data => {
  let model = data === null || data === void 0 ? void 0 : data.model;
  let timestamp = resolveTimeZone((data === null || data === void 0 ? void 0 : data.timestamp) || Date.now());
  const setData = data => {
    timestamp = resolveTimeZone(Date.now());
    model = data;
  };
  const getData = () => model;
  const getProductId = () => model.productId;
  const getDrawNumber = () => model.drawNumber;
  const getTimestamp = () => timestamp;
  const getRaceId = () => createRaceId(model.productId, model.drawNumber);
  const getDrawState = () => model.drawStateId;
  const isOutdated = () => timestamp.getTime() < Date.now() - constants.RACE_CACHE_TIME;
  return {
    get _symbol() {
      return raceSymbol;
    },
    setData,
    getData,
    getProductId,
    getDrawNumber,
    getTimestamp,
    getRaceId,
    getDrawState,
    isOutdated
  };
};
const toExport = {
  createRaceModel,
  isRaceModel,
  getRaceId: createRaceId
};
setGlobal('svs.components.sport.raceHandler.race', toExport);

 })(window);